import React from "react";
import Home from "./Home";
import { Row, Col, Icon, CardTitle, Card } from "react-materialize";
import { CheckAuth, API_COURSE_BASE_URL } from "../../Util";
import './Landingpage.css';
import $ from 'jquery';
import store from 'store';
import { Link } from 'react-router-dom';

class Course extends Home {
	constructor(props) {
		super(props);
		this.state = { 
			kursus: [],
			max_title_length: 45
		};
	}

	componentDidMount() {

		$.get(API_COURSE_BASE_URL, {journey : 1})
		.then((data) => {
		  let courseData = { kursus: data.payload };
		  store.set("course_data", courseData);

		//   console.log("COURSE DATA >>> ", courseData);
		  
		  this.setState(courseData);
  
	  });
  
	}

	componentDidUpdate(){
		this.handleIsIsw()
	}
	
	handleIsIsw = () => {
		const cardTitleCourse = document.querySelectorAll('.card-title-course')
		const cardTitle = document.querySelectorAll('.card-title-course .card-title')
		for ( let index = 0; index < cardTitleCourse.length; index++) {
			cardTitleCourse[index].style.display = 'flex';
			cardTitleCourse[index].style.position = 'relative';
		}
		for ( let index = 0; index < cardTitle.length; index++) {
			cardTitle[index].style.position = 'absolute';
			cardTitle[index].style.bottom = 0;
		}
	}

	renderTitle = (title) => {
		return title.length < this.state.max_title_length ? title : title.substring(0, this.state.max_title_length) + "..."
	}

	getKurses = () => {
		var course = (
		  this.state.kursus.map(item => (
			  <Col
				l={3}
				m={3}
				s={12}
			  >
				<Card
				  closeIcon={<Icon>close</Icon>}
				  header={<CardTitle className="card-title-course" image={item.thumbnail}>
					{
						item.is_isw ? (
							<div style={{position:'relative', bottom: '-9px'}}>
								<img 
									src="/img/isw-logo-white-small.png"
									style={{
										width: "50px"
									}}
								/>
							</div>
						):null
					}
				  </CardTitle>}
				  revealIcon={<Icon>more_vert</Icon>}
				>
				  <Link to={`/course/${item.slug}`}>
					  	<div className="content-desktop">{ this.renderTitle(item.title) }</div>
					  	<div className="content-mobile">{ item.title }</div> 
				  		{
								item.is_discount ? (
									<div>
										<div style={{display:'flex', alignItems:'center', gap:'2px'}}>
											<div style={{
												color:'white',
												background: '#ff00006e',
												borderRadius: '2px',
												padding: '1px'
												}}
											>
												{item.disc_percentage}
											</div>
											<div style={{ 
													bottom: "0px", 
													fontSize: '11px', 
													textDecoration: 'line-through',
													color: "red",
												}}
											>{item.price_text}</div>
										</div>
										<div style={{ bottom: "0px" }}>{item.final_price_text}</div>
									</div>
								) : (
									<div style={{ bottom: "0px" }}>Rp. {item.final_price_text}</div>
								)
							}
				  </Link>
				</Card>
			  </Col>          
		  ))
		)
		return course;
	}  

	render() {
        const sectionname = {
			color: "#df2e2e",
			margin: "10px",
            padding: "10px",
            fontSize: "1.5em",
            fontWeight: "bold",
            textAlign: "center"
        };

		let announcement = this.state.announcement;
		let isLogin = CheckAuth() != "";

		return (
			<div>

				<div className="bg-white pad-xl fadeIn wow">			
					<div style={sectionname}><h4>Daftar Kelas</h4></div>            
					<div className="container">
						<Row>
							{this.getKurses()}
						</Row>
					</div>
				</div>
                                
			</div>
		);
	}
}


export default Course;



// WEBPACK FOOTER //
// ./src/components/Public/Home/Course.js